function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import * as VacAdapter from './vac-config-adapter';
import * as MultiPlayerCsaiAdapter from './multi-player-csai-config-adapter';
import * as YospaceAdapter from './yospace-config-adapter';
import * as MediaTailorAdapter from './media-tailor-config-adapter';
// Client Config when Remote Config is disabled
export function adaptAdInsertionClientConfig() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _config_defaultConfig = config.defaultConfig, defaultConfig = _config_defaultConfig === void 0 ? {} : _config_defaultConfig, _config_clientConfig = config.clientConfig, clientConfig = _config_clientConfig === void 0 ? {} : _config_clientConfig;
    return _object_spread_props(_object_spread({}, clientConfig), {
        adPolicyConfig: defaultConfig.adPolicyConfig
    });
}
// Server Config when Remote Config is enabled
// Client Config when Remote Config is enabled
export function adaptAdInsertionRemoteConfigSplit(config) {
    var clientConfig = config.clientConfig, remoteConfig = config.remoteConfig;
    if (!(remoteConfig === null || remoteConfig === void 0 ? void 0 : remoteConfig.enabled) || !clientConfig) {
        return;
    }
    return {
        enabled: remoteConfig === null || remoteConfig === void 0 ? void 0 : remoteConfig.enabled,
        mediaTailorAdInsertionOverrideVod: remoteConfig === null || remoteConfig === void 0 ? void 0 : remoteConfig.mediaTailorAdInsertionOverrideVod,
        mediaTailorAdInsertionOverrideFer: remoteConfig === null || remoteConfig === void 0 ? void 0 : remoteConfig.mediaTailorAdInsertionOverrideFer,
        mediaTailorAdInsertionOverrideLinear: remoteConfig === null || remoteConfig === void 0 ? void 0 : remoteConfig.mediaTailorAdInsertionOverrideLinear,
        vac: VacAdapter.adaptVacRemoteConfigSplit({
            remoteConfig: remoteConfig.vac,
            clientConfig: clientConfig.vac
        }),
        mediaTailor: MediaTailorAdapter.adaptMediaTailorRemoteConfigSplit({
            remoteConfig: remoteConfig.mediaTailor,
            clientConfig: clientConfig.mediaTailor
        }),
        multiPlayerCsai: MultiPlayerCsaiAdapter.adaptMultiPlayerCsaiRemoteConfigSplit({
            remoteConfig: remoteConfig.multiPlayerCsai,
            clientConfig: clientConfig.multiPlayerCsai
        }),
        yospace: YospaceAdapter.adaptYospaceRemoteConfigSplit({
            remoteConfig: remoteConfig.yospace,
            clientConfig: clientConfig.yospace
        }),
        adPolicyConfig: remoteConfig.adPolicyConfig
    };
}

//# sourceMappingURL=ad-insertion-config-adapter.js.map